import { CONTRATO } from '../../../../constants/tipoContrato';

const CONTRATOS_CON_FECHA_FIN = [CONTRATO.TERMINO_FIJO, CONTRATO.OPS];

/**
 * Valida reglas de integridad referencial y lógica de negocio cruzada.
 */
export const validarReglasNegocio = (
  empleado,
  contexto,
  fechaIngreso,
  fechaHasta,
  lineaIndex
) => {
  const { conteoDocumentos } = contexto;

  return [
    ...verificarDuplicadosEnArchivo(
      empleado.NumeroDocumento,
      conteoDocumentos,
      lineaIndex
    ),
    ...verificarCoherenciaFechas(fechaIngreso, fechaHasta, lineaIndex),
    ...verificarFechaFinObligatoria(empleado, lineaIndex),
    ...verificarEntidadBancaria(empleado, contexto, lineaIndex),
  ];
};

const crearErrorDetalle = (linea, detalle) => ({ linea, detalle });

const verificarDuplicadosEnArchivo = (numeroDocumento, mapaConteo, linea) => {
  const repeticiones = mapaConteo.get(numeroDocumento) || 0;
  return repeticiones > 1
    ? [
        crearErrorDetalle(
          linea,
          'El documento está duplicado dentro del archivo Excel.'
        ),
      ]
    : [];
};

const verificarCoherenciaFechas = (fechaIngreso, fechaHasta, linea) => {
  if (
    fechaIngreso.isValid() &&
    fechaHasta.isValid() &&
    fechaHasta.isBefore(fechaIngreso)
  ) {
    return [
      crearErrorDetalle(
        linea,
        'La fecha de fin de contrato no puede ser anterior a la de ingreso.'
      ),
    ];
  }
  return [];
};

const verificarFechaFinObligatoria = (empleado, linea) => {
  const requiereFecha = CONTRATOS_CON_FECHA_FIN.includes(empleado.TipoContrato);
  if (requiereFecha && !empleado.FechaContratoHasta) {
    return [
      crearErrorDetalle(
        linea,
        "Para este tipo de contrato, 'FechaContratoHasta' es obligatoria."
      ),
    ];
  }
  return [];
};

const verificarEntidadBancaria = (empleado, contexto, linea) => {
  const { bancos } = contexto;
  const nombreBanco = empleado.entidadBancaria;

  if (!nombreBanco) return [];

  const bancoEncontrado = bancos.find(
    banco => banco.descripcion.toUpperCase() === nombreBanco.toUpperCase()
  );

  if (!bancoEncontrado) {
    return [
      crearErrorDetalle(
        linea,
        `La entidad bancaria '${nombreBanco}' no se encuentra en el Listado de bancos.`
      ),
    ];
  }

  empleado.codigoBancario = bancoEncontrado.codigo;
  return [];
};

/**
 * Valida que la novedad haga referencia a un empleado importado.
 * @param {Object} novedad - Novedad a validar.
 * @param {Set} empleadosSet - Set de números de documento de empleados importados.
 * @param {number} lineaExcel - Línea de Excel para el error.
 * @returns {Array} Array de errores (vacío si pasa la validación).
 */
export const verificarEmpleadoExisteEnNovedad = (
  novedad,
  empleadosSet,
  lineaExcel
) => {
  if (!empleadosSet.has(novedad.numeroDocumento)) {
    return [
      {
        linea: lineaExcel,
        detalle: `El número de documento ${novedad.numeroDocumento} no corresponde a ningún empleado registrado en la hoja de empleados.`,
      },
    ];
  }
  return [];
};

/**
 * Valida que la fecha fin no sea menor a la fecha de inicio en una novedad.
 * @param {Object} novedad
 * @param {number} lineaExcel
 * @returns {Array}
 */
export const verificarCoherenciaFechasNovedad = (novedad, lineaExcel) => {
  if (novedad.fechaInicio && novedad.fechaFin) {
    const inicio = new Date(novedad.fechaInicio);
    const fin = new Date(novedad.fechaFin);
    if (fin < inicio) {
      return [
        {
          linea: lineaExcel,
          detalle:
            'La fecha fin no puede ser menor a la fecha de inicio en la novedad.',
        },
      ];
    }
  }
  return [];
};
